const state = {
  stateVersion: null,
  loading: false,
};

const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener(state));
}

export function getState() {
  return state;
}

export function getStateVersion() {
  return state.stateVersion;
}

export function setStateVersion(version) {
  if (typeof version !== 'string' || !version || version === state.stateVersion) {
    return false;
  }

  state.stateVersion = version;
  emit();

  return true;
}

export function setLoading(value) {
  state.loading = Boolean(value);
}

export function subscribe(listener) {
  listeners.add(listener);

  return () => listeners.delete(listener);
}
